export const environment = {
    production: true,
    baseApiUrl: 'https://askhr-production-api.azurewebsites.net/',
    rootRoute: 'https://askhr-production-app.azurewebsites.net/',
    hotjarId: 3792532,
    googleAnalyticsId: 'GTM-5GTVP2NK',
    jiraCollectorId: '8c62100b',
    jiraBaseUrl: 'https://wize-solutions.atlassian.net'
};

